import { getPromos } from './getPromos';
import { IApplicationState } from '../../types/redux';

export function getPromoCount(state: IApplicationState): number {
  return getPromos(state).length;
}
